import { Link, useNavigate } from "react-router-dom";
import moment from 'moment';
import 'moment/locale/pt-br'
import api from "../../services/api.js";
import { useEffect, useState } from "react";
import { dadosLogin } from "../../zustand/zuztand.js";

import "../aniversario-colaboradores-mobile/aniversario-colaboradores-mobile.css";
import AniverCard from "../../components/aniver-franqueados-mobile/aniver-franqueados-mobile.jsx";

function AniversarioColaboradoresMobile() {

  const navigate = useNavigate();
  const { ifLogado, usuario, nivel_user } = dadosLogin()

  const local = moment().locale('pt-br').format('LL'); //converte a data par pt-br   ex: 12 de setembro de 2024 
  const mesAtuals = (local.split(" ")[2]); // converte 12 de setembro de 2024  em array e pega o indice 2 (mes extenço)
  const [dados, setDados] = useState([]);

  function PesquisarAniverColaboradores() {

    var mes = new Date();
    var month = mes.getMonth();
    var mesAtual = month + 1;

    let novo_array = [];

    api.get("/col_aniver_listar")
    .then((resp) => {
      //console.log(resp.data)
      resp.data.map((item) => {
        let dtaAniver = parseInt(item.data_nasc_col.substring(3, 5));

        if (dtaAniver === mesAtual) {
          novo_array.push({
            nome: item.nome_colaborador,
            data: item.data_nasc_col,
            img: item.foto_aniver
          })
        }
      })
      //console.log(novo_array)
      setDados(novo_array);
    })
    .catch((err) => {
      setDados([]);
      alert("Erro ao carregar dados");
    });    
  }

  useEffect(() => {
  PesquisarAniverColaboradores();
  }, []);

  return <>
    <div className="d-flex container-fundo-franqueado">
      <div className="d-block container-body-franqueado">
        {
          ifLogado !== "notLogad" ? <>

            <div className="d-flex justify-content-between">
              <div className="col-1">
              </div>
              <h4 className="ms-3 mt-2">
                Aniver Colaboradores: {mesAtuals}
              </h4>
              <Link to="/dashboard-mobile" className="btn btn-success p-2 me-5 mt-2 btn-sm" >Voltar </Link>
            </div>  

            <div className="coluna-aniversariantes-franqueado-mob">
            {
              dados.map((item) => {
                return <AniverCard
                  key={item.id_colab_fran}
                  nome={item.nome}
                  data={item.data}
                  img={item.img}
                />
              })
            }
            </div>
          </> : navigate('/login')
        }
      </div>
    </div>
  </>
}
export default AniversarioColaboradoresMobile;